import { defineComponent as _defineComponent } from 'vue'
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { ref } from 'vue';

import ApiErrorMessage from '@/components/widgets/ApiErrorMessage.vue';
import validateState from '@/composables/validateState';
import { t } from '~i18n';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RechargeForm',
  props: {
  /* Currently selected shop as object */
  shop: {
    type: Object,
    default: null,
  },
  /* Array of errors */
  errors: {
    type: Array,
    default: null,
  },
},
  emits: [
  'next',
],
  setup(__props, { emit }) {

const getters = store?.getters;
const form = store.state.customer?.form;





const submitButtonText = t('redeem.rechage.submit');
const campaign = ref(false);

const salutations = getters.getSalutations;

const rules = {
  firstName: { required },
  lastName: { required },
  street: { required },
  streetNumber: { required },
  postalCode: { required },
  city: { required },
  email2: { email },
};

const v$ = useVuelidate(rules, form);

const state = (v: string) => validateState(v, v$);

function next(): void {
  v$.value.$touch();
  if (!v$.value.$invalid) {
    form.campaign = campaign.value ? 'b2b-chargeable-vouchers-bonus' : 'b2c-chargeable-vouchers-bonus';
    emit('next');
  }
}

return { __sfc: true,getters, form, emit, submitButtonText, campaign, salutations, rules, v$, state, next, ApiErrorMessage, t }
}

})